<template>
  <v-dialog v-model="dialogs.consent" max-width="750px">
    <v-card style="" class="radius-20  ">
      <div class="text-right mt-2 mr-6 ">
        <span
          class="cursor-pointer fs24 mediumGrey"
          @click="dialogs.consent = false"
        >
          x
        </span>
      </div>
      <div
        style="overflow-y: scroll; height: 520px;"
        @scroll="onScroll"
        class="px-4 px-sm-12 darkBlue"
      >
        <div class="" ref="head">
          <p :class="fontTitle">นโยบายความเป็นส่วนตัว</p>
          <p class="" :class="fontHead">
            {{ consentData[indexConsent].head }}
          </p>
          <p class="" :class="fontConntent" style="white-space: pre-line">
            {{ consentData[indexConsent].content }}
          </p>
        </div>

        <div class="d-flex align-center justify-content-evenly ">
          <v-checkbox v-model="notApprove[indexConsent]" name="consent">
            <template v-slot:label>
              <span class="fs18 bold5 darkBlue">ไม่ยินยอม</span>
            </template></v-checkbox
          >
          <v-checkbox v-model="approve[indexConsent]" name="consent">
            <template v-slot:label>
              <span class="fs18 bold5 darkBlue">ยินยอม</span>
            </template>
          </v-checkbox>
        </div>
      </div>
      <hr class=" hr ma-0 mediumGrey" />
      <div class="py-7">
        <div
          class="flex-all-center  px-3 px-sm-10 "
          style="justify-content: space-evenly"
        >
          <Btn
            class="px-1"
            style="width:100%; max-width: 230px;"
            white
            :text="indexConsent > 0 ? 'ย้อนกลับ' : 'ยกเลิก'"
            radius="25"
            width="100%"
            height="40"
            fontSize="16"
            bold
            @click="back()"
          />

          <Btn
            :disabled="
              approve[indexConsent] !== null
                ? consentData[indexConsent].force
                  ? !approve[indexConsent]
                  : false
                : true
            "
            class="px-1"
            style="width:100%; max-width: 230px;"
            blue
            text="ถัดไป"
            radius="25"
            width="100%"
            height="40"
            fontSize="16"
            bold
            @click="
              indexConsent < 2 && indexConsent >= 0 ? scrollUp() : confirm()
            "
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import api from "@/api";
export default {
  props: {
    dialogs: {
      type: Object,
      default: () => {},
    },
    consentData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    dpSize: {
      deep: true,
      immediate: true,
      handler(dpSize) {
        if (dpSize === "xs") {
          this.fontTitle = "bold7 fs20";
          this.fontSection = "bold7 fs18";
          this.fontHead = "bold7 fs16";
          this.fontConntent = "bold5 fs16";
        } else {
          this.fontTitle = "bold7 fs24";
          this.fontSection = "bold7 fs20";
          this.fontHead = "bold7 fs18";
          this.fontConntent = "bold5 fs18";
        }
      },
    },
    approve: {
      deep: true,
      immediate: true,
      handler(approve, oldVal) {
        if (oldVal) {
          this.notApprove[this.indexConsent] = approve[this.indexConsent]
            ? false
            : true;
        }
      },
    },
    notApprove: {
      deep: true,
      immediate: true,
      handler(notApprove, oldVal) {
        if (oldVal) {
          this.approve[this.indexConsent] = notApprove[this.indexConsent]
            ? false
            : true;
        }
      },
    },
  },

  data() {
    return {
      approve: [null, null, null],
      notApprove: [false, false, false],
      fontTitle: "",
      fontSection: "",
      fontHead: "",
      fontConntent: "",
      indexConsent: 0,
    };
  },
  computed: {
    dpSize() {
      return this.$store.state.dpSize;
    },
  },
  methods: {
    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      if (scrollTop + offsetHeight >= scrollHeight) {
        // console.log("bottom!");
      }
    },

    scrollUp() {
      this.indexConsent += 1;
      this.$refs.head.scrollIntoView({ behavior: "smooth" });
    },

    confirm() {
      let consent = [];
      let key = ["INFORMATION", "PERSONAL_DATA", "BENEFITS"];

      key.forEach(async (key, index) => {
        consent.push({
          key: key,
          value: this.approve[index],
        });
      });
      // console.log(consent);
      this.$store.state.consent = consent;
      this.dialogs.consent = false;
      this.$emit("submit");
    },
    back() {
      if (this.indexConsent < 3 && this.indexConsent > 0) {
        this.indexConsent -= 1;
      } else {
        this.dialogs.consent = false;
        this.dialogs.privacyNotice = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
